// Function to convert date strings to date objects without time
export function convertToZeroTime(dateString) {
  const date = new Date(dateString)
  date.setHours(0)
  date.setMinutes(0)
  date.setSeconds(0)
  date.setMilliseconds(0)
  return date.toISOString() // Output format: "YYYY-MM-DDTHH:MM:SS.000Z"
}
